var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkExperience1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2790.79 2797.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bl{fill:url(#be);}.bm{fill:url(#t);}.bn{fill:url(#ap);}.bo{fill:url(#r);}.bp{fill:url(#bk);}.bq{fill:url(#ai);}.br{fill:url(#y);}.bs{fill:url(#l);}.bt{fill:url(#af);}.bu{fill:url(#aq);}.bv{fill:url(#u);}.bw{fill:url(#ah);}.bx{isolation:isolate;}.by{fill:url(#b`);}.c`{fill:url(#v);}.ca{fill:url(#av);}.cb{fill:url(#a`);}.cc{fill:url(#as);}.cd{fill:url(#m);}.ce{fill:url(#bh);}.cf{fill:url(#aw);}.cg{fill:url(#ba);}.ch{fill:url(#ao);}.ci{fill:url(#bj);}.cj{fill:url(#bd);}.ck{fill:url(#f);}.cl{fill:url(#bg);}.cm{fill:url(#ae);}.cn{fill:#91b3fa;}.co{fill:url(#bi);}.cp{mix-blend-mode:soft-light;}.cp,.cq{fill:#fff;}.cr{fill:url(#p);}.cs{fill:url(#g);}.ct{fill:url(#bb);}.cu{fill:url(#ad);}.cv{fill:url(#ab);}.cw{fill:url(#ak);}.cx{fill:url(#au);}.cy{fill:#7d97f4;}.d`{fill:url(#bf);}.da{fill:url(#i);}.db{fill:url(#bc);}.dc{fill:url(#aj);}.dd{fill:url(#ar);}.de{fill:url(#h);}.df{fill:url(#d);}.dg{fill:url(#e);}.dh{fill:url(#am);}.di{fill:url(#x);}.dj{fill:url(#at);}.dk{fill:url(#aa);}.dl{fill:url(#s);}.dm{fill:url(#n);}.dn{fill:url(#ac);}.do{fill:url(#w);}.dp{fill:url(#al);}.cq{opacity:.6;}.dq{fill:url(#j);}.dr{fill:url(#o);}.ds{fill:url(#an);}.dt{fill:url(#ax);}.du{fill:url(#q);}.dv{fill:url(#ag);}.dw{fill:url(#ay);}.dx{fill:url(#k);}.dy{fill:#bdd0fb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 907.76,
    y1: 3192.54,
    x2: -1030.55,
    y2: 1129.19,
    gradientTransform: "translate(677.79) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1909.81,
    y1: -733.47,
    x2: 1539.65,
    y2: 2248.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 979.81,
    y1: -1130.91,
    x2: 318.57,
    y2: -261.06,
    gradientTransform: "translate(610.29 585.3) rotate(23.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1368.93,
    y1: -270.04,
    x2: 698.19,
    y2: 612.31,
    gradientTransform: "translate(559.02 127.65) rotate(.69)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1610.06,
    y1: -469.65,
    x2: 1603.33,
    y2: 499.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 109.3,
    y1: 1824.21,
    x2: 896.56,
    y2: 3008.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -4277.33,
    y1: -560.88,
    x2: -4327.5,
    y2: -413.34,
    gradientTransform: "translate(4766.36 32.81) rotate(-30.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 847.89,
    y1: 1403,
    x2: 443.28,
    y2: 2101.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -2184.07,
    y1: 2344.61,
    x2: -2239.27,
    y2: 2725.99,
    gradientTransform: "translate(3030.12)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -2329.64,
    y1: 2672.21,
    x2: -2274.98,
    y2: 2672.21,
    gradientTransform: "translate(3030.12)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -1910.66,
    y1: 2384.18,
    x2: -1965.86,
    y2: 2765.56,
    gradientTransform: "translate(3030.12)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 759.84,
    y1: 2230.49,
    x2: 292.09,
    y2: 2822.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 5769.06,
    y1: 6792.61,
    x2: 5720.81,
    y2: 6767.16,
    gradientTransform: "translate(3030.12)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1462.91,
    y1: 1343.63,
    x2: 1153.32,
    y2: 1747.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 73.38,
    y1: 2422.15,
    x2: 614.09,
    y2: 1693.85,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -2619.8,
    y1: 1636.78,
    x2: -2503.02,
    y2: 1636.78,
    gradientTransform: "translate(3030.12)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -3119.13,
    y1: 2012.88,
    x2: -3285.57,
    y2: 2233.07,
    gradientTransform: "translate(2790.65 -1481.83) rotate(-20.41)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 302.05,
    y1: 801.13,
    x2: 450.12,
    y2: 1231.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -3362.9,
    y1: 2187.25,
    x2: -3229.4,
    y2: 2050.28,
    gradientTransform: "translate(2790.65 -1481.83) rotate(-20.41)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 836.35,
    y1: 1396.32,
    x2: 431.74,
    y2: 2095.2,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 474.47,
    y1: 1375.33,
    x2: 491.29,
    y2: 1964.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 382.67,
    y1: 1377.95,
    x2: 399.5,
    y2: 1966.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a`",
    x1: -2727.09,
    y1: 3010.51,
    x2: -2899.91,
    y2: 3290.93,
    gradientTransform: "translate(4252.01 -60.35) rotate(17.24)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 3008.55,
    y1: 1081.91,
    x2: 2820.29,
    y2: 1428.17,
    gradientTransform: "translate(-463.14)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 2720.46,
    y1: 1689.35,
    x2: 3305.12,
    y2: 2542.82,
    gradientTransform: "translate(-463.14)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 2561.04,
    y1: 1989.94,
    x2: 2826.16,
    y2: 1989.94,
    gradientTransform: "translate(-463.14)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1531.29,
    y1: 2312.18,
    x2: 2255.61,
    y2: 2309.2,
    gradientTransform: "translate(-463.14)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 5312.4,
    y1: 3022.75,
    x2: 4898.83,
    y2: 3258.81,
    gradientTransform: "translate(5392.85 -2532.14) rotate(156.28) scale(1 -1)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 2057.65,
    y1: 2515.71,
    x2: 2025.11,
    y2: 3014.61,
    gradientTransform: "translate(-1362.48 2524.64) rotate(-49.9)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 5475.56,
    y1: 2746.81,
    x2: 6925.78,
    y2: 1838.95,
    gradientTransform: "translate(6326.11 -1812.01) rotate(164.05) scale(1 -1)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 2053.49,
    y1: 1896.51,
    x2: 2020.95,
    y2: 2395.42,
    gradientTransform: "translate(-758.84 3137.17) rotate(-53.81)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 2781.99,
    y1: 1177.81,
    x2: 2553.16,
    y2: 1706.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 2228.74,
    y1: 1865.14,
    x2: 2622.69,
    y2: 1865.14,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 1922.86,
    y1: 1800.67,
    x2: 1894.07,
    y2: 1615.89,
    gradientTransform: "translate(425.73)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 2573.24,
    y1: 348.9,
    x2: 2759.33,
    y2: 475.3,
    gradientTransform: "translate(96.51 3127.36) rotate(-43.7)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 2597.24,
    y1: 1001.88,
    x2: 2472.74,
    y2: 1207.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 2584.39,
    y1: 332.48,
    x2: 2770.48,
    y2: 458.88,
    gradientTransform: "translate(96.51 3127.36) rotate(-43.7)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 2143.98,
    y1: 2087.61,
    x2: 2287.68,
    y2: 1381.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 2138.43,
    y1: 2086.48,
    x2: 2282.13,
    y2: 1380.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 2186.65,
    y1: 2096.3,
    x2: 2330.35,
    y2: 1390.56,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 2168.37,
    y1: 2092.58,
    x2: 2312.07,
    y2: 1386.84,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 2151.81,
    y1: 2089.2,
    x2: 2295.51,
    y2: 1383.47,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 2135,
    y1: 2085.78,
    x2: 2278.7,
    y2: 1380.05,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 2114.21,
    y1: 2081.55,
    x2: 2257.92,
    y2: 1375.81,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 2208.28,
    y1: 2100.7,
    x2: 2351.99,
    y2: 1394.97,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 2227.13,
    y1: 2104.54,
    x2: 2370.83,
    y2: 1398.81,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 2234.78,
    y1: 2106.1,
    x2: 2378.48,
    y2: 1400.36,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 2144.1,
    y1: 2087.63,
    x2: 2287.8,
    y2: 1381.9,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b`",
    x1: 2144.73,
    y1: 2087.76,
    x2: 2288.43,
    y2: 1382.02,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 2137.25,
    y1: 2086.24,
    x2: 2280.96,
    y2: 1380.51,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 2136.28,
    y1: 2086.04,
    x2: 2279.98,
    y2: 1380.31,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 2129.66,
    y1: 2084.69,
    x2: 2273.36,
    y2: 1378.96,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 2100.74,
    y1: 2078.8,
    x2: 2244.44,
    y2: 1373.07,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 2071.26,
    y1: 2072.8,
    x2: 2214.96,
    y2: 1367.07,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 2048.22,
    y1: 2068.11,
    x2: 2191.93,
    y2: 1362.38,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 2055.79,
    y1: 2036.27,
    x2: 2478.01,
    y2: 2036.27,
    gradientTransform: "translate(425.73)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 1666.75,
    y1: 1003.62,
    x2: 1706.27,
    y2: 1003.62,
    gradientTransform: "translate(1465.07 .92) rotate(42.13)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: -683.06,
    y1: 906.23,
    x2: -1177.71,
    y2: 3677.24,
    gradientTransform: "translate(677.79) rotate(-180) scale(1 -1)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 1451.13,
    y1: 439.62,
    x2: 1504.97,
    y2: -919.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 1050.27,
    y1: 1569.14,
    x2: 2223.41,
    y2: 1569.14,
    xlinkHref: "#k"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "M352.01,2364.73c71.55,73.76,135.58,117.11,184.6,149.84,478.07,319.21,1024.57,227.21,1193.53,195.76,272.6-50.74,502.71-86.53,700.42-265.15,449.25-405.88,427.4-1252.57,84.12-1777.06-40.7-62.19-383.46-570.27-931.14-641.86-13.4-1.75-23.39-2.75-32.14-3.68-84.72-8.97-609.74-56.31-1037.84,302.35-61.28,51.34-159.9,143.95-251.35,285.18C-72.19,1126.56-73.25,1926.39,352.01,2364.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M768.02,1665.18s8.55-359.56-157.06-455.79c-165.61-96.23-480.49-156.4-492.29-672.69-6.91-302.26-14.39-434.41-19.4-492.04-1.96-22.48,18.02-40.62,40.19-36.45,156.84,29.55,666.36,151.16,773.19,498.93,126.64,412.29-144.63,1158.02-144.63,1158.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "M260.77,151.87c172.17,153.55,371.25,425.3,477.36,697.05,13.62,44.79,53.46,140.03,70.76,309.25,15.45,141.13,7.77,290.27-10.97,388.99-1.18,6.24-7.2,10.34-13.45,9.16-10.73-2.04-9.3-13.58-9.21-13.21,21.4-168.67,12.52-378.6-36.52-568.02-62.65-232.59-202.37-458.09-346.9-649.35l-14.87-18.83c-111.97-143.8-135.54-144.86-125.08-154.88,2.47-2.37,6.34-2.39,8.86-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M1037,2275.58c22.41,10.99-212.12-283.93-285.58-747.12-34.62-218.27-35.07-491.74-159.4-597.12-103.48-87.71-455.61-32.34-570.82-11.29-14.4,2.63-19.24,20.82-8.04,30.23,55.25,46.4,170.45,156.74,204.24,266.16,81.29,263.2,180.94,244,302.57,262.9,124.76,19.38,192.59,49.32,252.88,247.22,60.29,197.9,200.49,517.81,264.16,549.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "M183.24,981.48c147,6.16,304.79,73.21,384.86,198.99l7.56,12c17.46,28.14,116.38,228.21,171.33,394.05,.68,2.07-.44,4.3-2.5,4.98-3.51,1.16-5.27-2.7-4.94-2.36-38.28-93.69-93.26-212.47-137.05-301.3-46.96-96.93-79.82-162.57-186.94-225.45-119.22-67.72-233.12-74.69-232.78-74.62-1.74-.18-3-1.73-2.83-3.47,.17-1.67,1.62-2.91,3.28-2.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "M869.98,311.43l1458.18,17.58c80.45,.97,146.02,64.81,149.14,145.21l82.15,2115.39c2.44,62.91-47.69,115.34-110.64,115.73l-1671.62,10.23c-59.16,.36-107.1-47.87-106.39-107.02l25.65-2127.7c1.14-94.7,78.84-170.54,173.54-169.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M874.67,294.35c198.8,29.4,882.54,121.18,1449.21,84.54,25.84-1.67,48.01,18.16,49.08,44.04l87.26,2124.87c1.2,29.14-21.34,53.77-50.47,55.14-238.28,11.22-1219.54,53.87-1568.87,13.02-21.26-2.49-37.2-20.6-37.07-42.01l13.77-2230.6c.19-30.3,27.12-53.43,57.09-49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "M895.33,349.69c191.32,28.3,849.31,116.61,1394.64,81.36,24.87-1.61,46.2,17.48,47.23,42.38l83.98,2044.86c1.15,28.04-20.53,51.74-48.57,53.06-229.31,10.8-1173.62,51.84-1509.79,12.53-20.46-2.39-35.8-19.83-35.68-40.43l13.25-2146.61c.18-29.16,26.09-51.42,54.94-47.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "M1001.27,593.74c165.6,20.21,735.11,83.42,1206.89,59.79,21.52-1.08,40.01,12.34,40.95,29.8l76.71,1433.52c1.05,19.66-17.66,36.23-41.92,37.1-198.39,7.11-1015.39,34.01-1306.34,5.79-17.71-1.72-31.02-13.97-30.95-28.41l7.21-1504.65c.1-20.44,22.48-35.99,47.44-32.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "M1692.98,33.06c-52.23-37.28-98.04-37.1-130.39-27.98-29.51,8.32-48.92,36.49-46.49,67.06l12.07,151.93,165.27,16.68s101.97-134.58-.46-207.68Zm-74.23,121.55c-22.78-.27-41.03-18.97-40.76-41.75,.27-22.78,18.97-41.03,41.75-40.76,22.78,.27,41.03,18.97,40.76,41.75-.27,22.78-18.97,41.03-41.75,40.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M1545.52,159.8c-1.74,0-3.21-1.34-3.35-3.1l-1.92-24.19c-.15-1.85,1.24-3.47,3.09-3.62,1.85-.13,3.47,1.24,3.62,3.09l1.92,24.19c.15,1.85-1.24,3.47-3.09,3.62-.09,0-.18,0-.27,0Zm-3.77-47.41c-1.74,0-3.21-1.34-3.35-3.1l-1.46-18.37c-2.29-28.82,16.15-55.41,43.84-63.23,19.71-5.55,39.97-6.14,60.19-1.75,1.82,.39,2.97,2.19,2.58,4-.4,1.82-2.19,2.97-4,2.58-19.15-4.16-38.3-3.61-56.94,1.65-24.61,6.94-41,30.58-38.96,56.21l1.46,18.37c.15,1.85-1.24,3.47-3.09,3.62-.09,0-.18,0-.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "M1301.18,319.42l.92-76.3c.32-26.34,22.4-47.17,48.71-45.95l525.83,24.36c23.34,1.08,42.02,19.74,43.14,43.07l3.51,73.37-622.12-18.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M1498.51,227.08h-.04l-22.62-.27c-1.86-.02-3.35-1.55-3.33-3.4,.02-1.86,1.59-3.36,3.4-3.33l22.62,.27c1.86,.02,3.35,1.55,3.33,3.4-.02,1.85-1.52,3.33-3.37,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M1329.99,295.18h-.03c-1.87-.02-3.36-1.55-3.34-3.4l.37-30.86c.14-11.39,4.7-22.04,12.85-29.99,8.15-7.96,19.04-12.2,30.29-12.12l83.17,1c1.86,.02,3.35,1.55,3.33,3.4-.02,1.86-1.51,3.32-3.4,3.33l-83.17-1c-.15,0-.3,0-.45,0-9.42,0-18.3,3.61-25.06,10.21-6.86,6.7-10.7,15.67-10.82,25.25l-.37,30.86c-.02,1.85-1.52,3.33-3.37,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M1136.69,289.51l919.9,11.06c33.08,.4,61.07,24.54,66.32,57.2l.72,4.51c5.75,35.77-22.13,68.1-58.36,67.66l-943.76-11.38c-21.68-.26-38.74-18.6-37.44-40.24l2.54-42.22c1.59-26.41,23.63-46.91,50.08-46.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cq",
    x: 944.77,
    y: 2252.57,
    width: 843.98,
    height: 57.92,
    rx: 8.61,
    ry: 8.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cq",
    x: 942.35,
    y: 2351.29,
    width: 843.98,
    height: 57.92,
    rx: 8.61,
    ry: 8.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cq",
    x: 935.62,
    y: 2449.43,
    width: 843.98,
    height: 57.92,
    rx: 8.61,
    ry: 8.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cy",
    x: 196.3,
    y: 2414.09,
    width: 474.48,
    height: 84.13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M186.74,2407.36l33.78,342.11c1.43,14.47,7.34,24.69,14.18,24.69h13.53c7.66,0,14-12.75,14.47-29.29l9.75-337.51h-85.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M679.97,2430.92l-33.78,342.11c-1.43,14.47-7.34,24.69-14.18,24.69h-13.53c-7.66,0-14-12.75-14.47-29.28l-9.75-337.51h85.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "M751.28,2282.63c-5.8-11.28-14.31-17.57-22.49-17.49l-457.17,4.91c-12.89,.14-24.92-13.66-31.01-35.85L86.26,1672.48c-10.04-36.57-32.13-53.69-52.27-40.57l-4.14,2.68c-11.56,7.53-20.98,24.16-25.99,45.87-5,21.71-5.14,46.52-.37,68.44l129.18,593.47c12.16,55.89,39.93,92.69,70.99,94.09l507.63,22.87c12.57,.57,26.02-8.8,35.01-25.97,8.99-17.18,15.35-40.72,15.35-65.3v-42.83c0-16-4.56-31.33-10.36-42.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dq",
    d: "M857.59,1672.03l-6.33-10.29c-3.64-5.92-9.78-9.87-16.68-10.72l-67.34-8.35s-2.99-7.56,9.39-16.52c12.37-8.95,5.06-23.53,5.06-23.53,0,0-16.55,13.57-40.5,34.49-13.7,11.96-18.89,28.06-20.84,39.65l-10.78,23.63c6.02,7.09,15.31,12.7,29.45,10.91l2.45-18.09c40.49,1.33,79.02-6.57,116.11-21.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "M709.57,1698.66c-7.25,15.9-14.46,31.81-21.7,47.71-9.32,20.44-17.1,46.57-32.09,63.64-17.67,20.13-46.61,16.6-64.7-.99-19.84-19.28-41.03-37.03-61.55-55.6-5.41-4.9-10.97-9.63-16.42-14.48l-1.55,124.85c50.01,22.79,105.07,61.34,162.36,41.75,15.78-5.39,31.58-15.43,40.55-29.83,5.37-8.62,9.95-20.57,10.99-30.73,0-.02,13.79-135.24,13.79-135.24-16.32,2.07-22.72-2.9-29.67-11.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M771.63,2733.94c-49.53,0-71.44-4.25-81.24-8.12,1.9,8.13,9.15,14.56,18.3,14.56h175.21c5.9,0,9.62-5.65,8.21-10.76-19.97,1.61-62.39,4.33-120.49,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M892.12,2729.6c-.28-1.03-.7-2.05-1.43-2.98-13.35-17.04-40.16-43.8-76.63-43.29-53.43,.75-72.06,6.55-113.58,.33l-9.8,32.47c-1,3.31-1.02,6.61-.3,9.68,9.8,3.88,31.71,8.12,81.24,8.12,58.1,0,100.52-2.72,120.49-4.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "M712.5,2648.67l-12.02,40.89s26.64,12.13,50.06,2.39l4.6-35.43-42.64-7.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M1075.66,2708.18c-38.61,31.02-58.34,41.45-68.39,44.58,6.55,5.12,16.2,5.56,23.34-.17l136.59-109.75c4.6-3.7,3.98-10.41-.3-13.49-14.57,13.76-45.94,42.44-91.23,78.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dm",
    d: "M1166.88,2629.35c-.86-.62-1.82-1.15-2.98-1.42-21.03-4.86-58.61-8.83-86.72,14.41-41.18,34.05-52.09,50.21-88.33,71.39l12.6,31.32c1.29,3.19,3.33,5.77,5.81,7.7,10.05-3.13,29.79-13.56,68.39-44.58,45.29-36.39,76.66-65.08,91.23-78.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dr",
    d: "M455.31,2182.79s296.52,24.21,357.35,52.85c60.83,28.64-49.64,429.98-49.64,429.98,0,0-16.56,7.97-53.41-3.48,0,0,37.79-296.17,9.67-360.4l-321.06-52.51,57.09-66.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "M959.39,2657.36c2.75,2.51,29.46,56.38,29.46,56.38,0,0,29.73-6.43,35.8-25.25l-26.75-48.62-38.51,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "du",
    d: "M276.71,2180.31s-9.66,23.25-9.27,54.15c.55,42.73,34.9,77.41,77.58,79.54l350.54,15.99c7.4,.34,13.67,5.46,15.52,12.64,8.24,31.86,48.5,129.71,245.32,324.94,5.24,5.19,13.39,6.08,19.63,2.14l28.02-17.7c2.94-1.86,3.88-5.71,2.12-8.72l-204.1-348.54c-10.72-17.69-27.95-30.47-47.99-35.59l-298.77-76.37-178.59-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M275.77,2179.28s-3.48-173.74,31.26-337.25c12.83-60.38,46.21-114.44,94.69-152.64l16.22-12.78,81.24,33,41.75,72.14c22.98,45.97,17.34,145.79,0,194.17-28.99,80.89-52.18,164.72-62.06,205.89,0,0-134.55,17.77-203.1-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dl",
    d: "M473.79,1547.14l-63.47,147.25s20.31,45.7,91.39,27.93l25.39-101.55-53.31-73.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M599.57,1479.99c.76,2.06,2.45,147.12,2.45,147.12l-82.85-.8-22.02-137.26s89.62-43.5,102.43-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M521.44,1515.45l5.93,73.16c.08,.94,.27,1.84,.6,2.72,2,5.4,10.25,23.49,28.24,13.92,16.32-8.68,31.34-16.36,43.08-15.38,5.27,.44,9.34,4.81,9.4,10.09,.15,13.18-.06,42.89-4.19,68.67-.84,5.23-5.57,8.91-10.86,8.53-15.92-1.13-49.44-4.45-75.78-13.44-3.57-1.22-6.19-4.25-6.83-7.96-3.12-18.12-12.82-73.15-17.9-88.07-4.76-14-24.25-18.79-32.57-20.22-2.73-.47-5.12-2.02-6.67-4.32-5.47-8.12-14.8-27.62,9.29-41.65,5.04-2.94,6.64-9.4,3.55-14.35-6.15-9.86-11.29-25.81,6.81-39.13,18.4-13.54,35.97-5.96,46.09,1.09,4.09,2.85,9.54,2.24,13.1-1.25,2.03-1.99,4.94-3.13,9.09-1.64,5.58,2,11.65-1.5,13.06-7.26,2.72-11.07,10.34-23.95,31.03-24.84,36.71-1.59,49.19,36.77,44.82,61.77-4.37,25-44.26,24.46-65.83,17-16.4-5.68-33.2,7.62-40.32,14.32-2.25,2.12-3.39,5.15-3.14,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c`",
    d: "M495.56,1594.32s5.74-43.89-11.36-50.64c-17.11-6.75-38.13,3.22-26.87,31.68,14,35.41,38.24,18.96,38.24,18.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "do",
    d: "M669.33,2039.74c-209.23,65.68-198.1-228.81-199.45-230.88-82.94-126.75-129.52,42.16-121.48,65.97,73.57,266.35,259.03,253.16,331.29,200.84-9-14-11.05-26.32-10.36-35.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "M508.94,1994.31c-1.16-.36-2.19-1.11-2.9-2.21-31.7-49.4-40.65-118.05-42.57-166.94-.12-2.94,2.17-5.41,5.11-5.53,2.94-.12,5.41,2.17,5.53,5.11,1.53,38.94,8.88,111.72,40.89,161.61,1.59,2.47,.87,5.77-1.61,7.35-1.38,.88-3.01,1.05-4.46,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M450.52,2061.23c-.66-.2-1.28-.54-1.84-1-47.82-40.07-83.85-103.04-107.08-187.16-.78-2.83,.88-5.77,3.71-6.55,2.83-.78,5.77,.88,6.55,3.71,22.65,82,57.52,143.17,103.66,181.83,2.25,1.89,2.55,5.25,.66,7.5-1.42,1.69-3.67,2.28-5.66,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M792.5,1978.25s-3.4,5.43-27.89,24.41c-24.5,18.98-49.16,29.93-30.43,3.85s9.61-39.55-11.76-11.45c-21.37,28.1-36.65,38.96-36.65,38.96-5.62,2.15-11.1,4.05-16.43,5.73-.69,9.61,1.36,21.93,10.36,35.93,8.48-2.8,13.26-4.87,13.26-4.87,0,0,64.8-11.79,78.67-39.38,13.88-27.59,20.87-53.17,20.87-53.17Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dk",
    d: "M2274.79,1460.55s-13.05-49.11,56.39-57.3c69.44-8.19,88.75,111.32,33.7,127.47-55.05,16.15-90.1-70.17-90.1-70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "M2747.95,1720.32c-21.51-23.27-51.69-36.6-83.38-36.82l-415.45-2.94c-33.8-.24-65.98,14.45-87.95,40.13-21.97,25.69-31.48,59.67-26,93.02l83.19,506.16h523.01l36.76-513.63c2.26-31.61-8.66-62.65-30.17-85.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "dn",
    points: "2108.62 1965.12 2330.02 1960.47 2363.01 2019.41 2097.9 2007.39 2108.62 1965.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cy",
    x: 2279.3,
    y: 2515.05,
    width: 370.16,
    height: 40.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M2250.3,2340.06l26.48,432.63c.18,2.86,2.28,8.2,4.81,8.2h17.46c2.66,0,7.16-6.38,7.16-9.39v-431.43h-55.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M2687.86,2340.06l-26.48,432.63c-.18,2.86-2.28,8.2-4.81,8.2h-17.46c-2.66,0-6.48-6.38-6.48-9.39v-431.43h55.23Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cu",
    x: 2151.42,
    y: 2245.84,
    width: 639.37,
    height: 121.14,
    rx: 59.78,
    ry: 59.78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "M1956.99,2706.89c.38-.38,57.08-539.57,72.52-594.75,2.6-9.28,9.73-16.56,18.95-19.37l72.3-22,155.91,91.61-167.34,28.3c53.74,86.17-58.89,298.82-96.2,374.75-3.79,7.71-.29,16.99,7.63,20.29l34.53,14.36c-21.53,56.42-55.23,101.38-100.66,135.29l2.36-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M2035.74,2592.73s17.24-1.76,28.25,9.44c5.27,5.36,5.84,13.8,2.01,20.27-17.03,28.73-73.74,122.24-106.63,150.13-2.7,2.29-6.88,.78-7.57-2.69-1.92-9.64-3.35-29.95,5.59-64.53l-.2,4.47c-.25,5.66,6.93,8.27,10.32,3.74,19.03-25.4,56.83-79.32,68.23-120.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dv",
    d: "M2062.94,2730.82c.35-.4,12.43-104.93,12.79-105.33-26.31-226.66,7.46-436.88,19.1-492.98,1.96-9.44,8.58-17.18,17.59-20.61l70.63-26.87,166.54,128.1-169.78-7.68c59.48,82.31-38.43,302.13-70.48,380.42-3.25,7.95,.86,16.97,9,19.72l35.43,11.98c-17.64,57.75-48.2,104.9-91.22,141.82l.42-28.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M2133.74,2611.57s17.08-2.93,28.83,7.5c5.62,4.99,6.76,13.37,3.38,20.08-15.03,29.82-65.26,126.98-96.17,157.03-2.53,2.46-6.81,1.24-7.73-2.17-2.57-9.49-5.38-29.65,1.18-64.77l.1,4.47c.13,5.66,7.48,7.78,10.55,3.03,17.25-26.64,51.3-83,59.85-125.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M2627.41,2211.3c-5.59-46.21-73.7-147.53-73.7-147.53,0,0-264.2-8.59-295.06,3.38-23.95,9.29-121.67,4.04-164.21,1.23-1.62-.11-3.08,.97-3.46,2.54-.38,1.58,.42,3.2,1.91,3.85,103.92,45.2,113.91,70.96,127.65,158.58,0,0,104.59,63.58,316.74,46.04,71.29-5.89,95.72-21.88,90.13-68.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "M2369.49,2048.76s-79.32-75.53-118.37-125.56c-21.11-27.04-27.73-62.64-17.97-95.53,17.83-60.06,49.51-122.26,52.4-131.94,4.43-14.84,93.37-14.22,93.37-14.22,0,0,175.02,113.59,243.78,305.99l-77.23,24.04s-45.7-76.66-90.85-125.41c0,0,78.13,103.21,80.88,145.46l-166.01,17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "M2274.79,1612.8c.93,3.08,24.14,80.04,25.96,81.64,1.82,1.6,50.91,4.24,74.02-11.56l-47.16-104.34-52.81,34.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dp",
    d: "M2210.95,1526.36s-16.53,38.17,2.89,96.21c19.42,58.04,51.15,63.08,71.25,48.73,20.1-14.35,46.15-39.99,49.39-92.56,3.24-52.57-100.77-100.67-123.53-52.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "M2299.79,1461.9c-18.92-10.41-38.67-13.3-56.96-10.62-13.87,1.96-26.91,7.11-38.2,14.59-11.49,7.53-20.66,17.42-27.46,28.81-2.22,4.61-3.79,9.48-4.8,14.6-3.78,19.22,1.33,39.12,13.89,54.15,9.4,11.25,18.88,20.55,18.88,20.55l1.64-11.82c0-14.79,11.64-30.78,26.08-35.37,14.43-4.59,29.68-.98,40.66,9.38,14.23,13.45,22,31.49,22,31.49l4.71-1.39s-.38-22.99,14.21-17.63c14.54,5.41,20.48,35.77,20.48,35.77,0,0,30.91,14.18,33.8-27.16,2.89-41.29-15.32-75.98-68.93-105.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ds",
    d: "M2307.32,1576.29s-18.26-40.27,7.32-41.73c25.58-1.46,15.17,38.82,10.08,53.52l-17.39-11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M2193.37,1560.02c-.25,0-.5-.11-.67-.32-.35-.42-34.32-42.52,.08-74.12,.36-.32,.9-.3,1.23,.05s.3,.9-.05,1.23c-33.2,30.5-.25,71.32,.08,71.73,.31,.37,.25,.92-.12,1.23-.16,.13-.36,.2-.55,.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "ch",
    cx: 2171.35,
    cy: 1953.19,
    rx: 149.65,
    ry: 156.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bn",
    cx: 2165.33,
    cy: 1954.34,
    rx: 141.11,
    ry: 147.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M2142.18,2040.78c-1.83,0-3.58-1.06-4.38-2.83-1.08-2.41,0-5.25,2.42-6.33,49.69-22.21,98.75-62.89,134.62-111.6,1.57-2.13,4.57-2.58,6.7-1.02,2.13,1.57,2.59,4.57,1.02,6.7-36.82,50-87.28,91.8-138.43,114.67-.64,.29-1.3,.42-1.95,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "M2135.77,2019.28c-1.71,0-3.37-.92-4.23-2.54-1.24-2.33-.36-5.23,1.98-6.48,43.74-23.3,85.12-59.61,116.52-102.26,1.57-2.13,4.57-2.58,6.7-1.02,2.13,1.57,2.59,4.57,1.02,6.7-32.7,44.41-74.11,80.73-119.73,105.03-.72,.38-1.49,.56-2.25,.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M2129.75,2000.95c-1.61,0-3.18-.81-4.08-2.28-1.39-2.25-.69-5.2,1.57-6.59,37.89-23.34,72.39-55.31,99.76-92.47,1.57-2.13,4.57-2.58,6.7-1.02,2.13,1.57,2.59,4.57,1.02,6.7-28.09,38.14-63.51,70.97-102.45,94.95-.78,.48-1.65,.71-2.51,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dj",
    d: "M2123.44,1979.22c-1.5,0-2.98-.7-3.91-2.02-1.53-2.16-1.02-5.15,1.14-6.68,37.31-26.46,63.09-50.67,83.6-78.53,1.57-2.13,4.57-2.58,6.7-1.02,2.13,1.57,2.59,4.57,1.02,6.7-21.14,28.71-47.6,53.59-85.77,80.66-.84,.6-1.81,.88-2.77,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "M2118.16,1951.28c-1.35,0-2.69-.57-3.64-1.67-1.72-2.01-1.49-5.03,.52-6.75,2.85-2.44,5.69-4.85,8.51-7.24,18.01-15.26,35.02-29.68,49.57-49.43,1.57-2.13,4.57-2.58,6.7-1.02,2.13,1.57,2.59,4.57,1.02,6.7-15.21,20.66-32.64,35.43-51.09,51.06-2.81,2.38-5.63,4.78-8.47,7.2-.9,.78-2.01,1.16-3.12,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "M2154.75,2064.69c-1.89,0-3.68-1.13-4.44-2.98-1-2.45,.18-5.24,2.63-6.24,53.47-21.77,108.15-66.44,146.27-119.49,1.54-2.14,4.54-2.63,6.68-1.09,2.15,1.54,2.64,4.54,1.09,6.69-39.13,54.45-95.37,100.34-150.44,122.76-.59,.24-1.2,.36-1.8,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "M2169.78,2091.69c-1.8,0-3.52-1.02-4.34-2.76-1.12-2.39-.09-5.24,2.31-6.37,54.54-25.55,110.82-75.64,146.87-130.72,1.45-2.21,4.42-2.83,6.63-1.38,2.21,1.45,2.83,4.42,1.38,6.63-36.97,56.47-94.76,107.87-150.82,134.14-.66,.31-1.35,.45-2.03,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dt",
    d: "M2178.7,2106.18c-1.8,0-3.52-1.02-4.33-2.75-1.13-2.4-.11-5.25,2.29-6.38,34.67-16.35,98.18-51.83,134-105.76,1.46-2.2,4.44-2.81,6.64-1.34,2.2,1.46,2.8,4.44,1.34,6.64-37.11,55.86-102.32,92.34-137.89,109.11-.66,.31-1.36,.46-2.04,.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dw",
    d: "M2320.59,1959.93c-1.31,0-2.62-.54-3.57-1.59-54.26-60.53-180.92-85.89-282.33-56.54-2.53,.72-5.2-.73-5.93-3.27-.74-2.54,.73-5.2,3.27-5.94,104.6-30.27,235.64-3.65,292.12,59.34,1.77,1.97,1.6,5-.37,6.76-.91,.82-2.06,1.23-3.19,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M2317.14,1926.58c-1.27,0-2.54-.5-3.48-1.5-52.22-55.16-164.27-79.94-260.67-57.6-2.56,.6-5.15-1.02-5.75-3.59-.6-2.58,1.01-5.15,3.59-5.75,99.44-23.02,215.42,2.92,269.79,60.35,1.82,1.92,1.74,4.95-.18,6.77-.93,.87-2.11,1.31-3.29,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "M2295.41,1873.52c-.82,0-1.66-.21-2.42-.66-61.37-36-142.77-47.83-217.76-31.65-2.59,.58-5.14-1.09-5.69-3.67-.56-2.59,1.09-5.14,3.67-5.69,77.27-16.68,161.24-4.43,224.62,32.75,2.28,1.34,3.05,4.27,1.71,6.55-.89,1.52-2.49,2.37-4.14,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M2268.69,1839.94c-.62,0-1.25-.12-1.85-.37-49.33-20.74-101.66-28.51-155.55-23.08-2.64,.21-4.98-1.66-5.25-4.29-.26-2.63,1.66-4.98,4.29-5.24,55.49-5.57,109.4,2.42,160.22,23.78,2.44,1.02,3.59,3.83,2.56,6.27-.77,1.83-2.55,2.93-4.42,2.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "M2182.03,2111.22c-1.47,0-2.93-.68-3.87-1.96-45.29-61.72-71.28-145.41-69.51-223.87,.06-2.65,2.23-4.77,4.9-4.68,2.65,.06,4.74,2.25,4.68,4.9-1.71,76.43,23.58,157.92,67.66,217.99,1.56,2.13,1.11,5.13-1.03,6.7-.85,.63-1.85,.93-2.83,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "M2147.57,2110.23c-1.56,0-3.09-.76-4.01-2.16-42.34-64.38-65.05-147.2-60.75-221.56,.15-2.64,2.44-4.66,5.06-4.5,2.64,.15,4.66,2.42,4.51,5.06-4.19,72.37,17.93,153.03,59.19,215.74,1.45,2.21,.84,5.18-1.37,6.64-.81,.53-1.73,.79-2.63,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M2116.88,2101.39c-1.58,0-3.13-.78-4.04-2.21-37.36-58.58-60.29-138.27-59.85-207.97,.02-2.64,2.16-4.67,4.82-4.76,2.65,.02,4.78,2.18,4.76,4.82-.43,67.95,21.92,145.65,58.34,202.75,1.42,2.23,.77,5.19-1.46,6.61-.8,.51-1.69,.75-2.57,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d`",
    d: "M2087.14,2086.82c-1.57,0-3.11-.77-4.03-2.19-33.85-52.41-46.16-131.74-46.39-188.5-.01-2.64,2.13-4.8,4.77-4.81h.02c2.64,0,4.78,2.13,4.79,4.77,.23,55.4,12.13,132.66,44.86,183.34,1.44,2.22,.8,5.18-1.42,6.62-.8,.52-1.71,.77-2.59,.77Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "M2218.36,2078.57l59.6-64.85,68.83,18.54s80.25,12.43,126.18,0l45.93-12.43,103.79-32.31,16.3,46.07c4.14,11.7-.02,24.68-10.13,31.87-8.98,6.38-19.51,13.39-26.21,16.33-13.67,5.98-314.86,1.89-314.86,1.89l-69.42-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "M2040.86,1849.21s35.99-7.33,30.62-.15c-5.37,7.18-18.91,20.9-18.91,20.9,0,0,.67,5.5-3.76,19.55s-16.08,31.85-22.31,28.79c-6.23-3.06-1.91-54.84,14.36-69.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "M974.59,2043.35l76.76-356.13c13.42-78.88-13.1-160.8-70.97-219.87h0c-31.77-32.43-51.71-73.98-56.16-117.95-6.94-68.55-6.11-180.17,39.79-316.67,61.62-183.26,252.78-300.59,458-277.69,104.53,11.66,228.43,39.89,361.16,99.37,77.54,34.74,131.22,103.68,139.76,183.38,3.98,37.11,11.35,78.26,24.78,114.92,16.93,46.24,24.29,77.94,27.33,98.52,2.76,18.67-5.25,37.15-20.98,49.11h0c-16.15,12.29-20.15,33.43-9.55,50.37l118.83,189.92v6.05c0,18.75-16.13,33.69-36.82,34.16l-71.64,1.64,2.7,66.21c.52,12.79-8.72,23.8-22.28,26.56l-16.2,3.3,14.79,11.42c12.05,9.31,15.23,24.93,7.44,36.68l-20.89,31.53c-9.43,14.23-8.08,32.74,3.41,46.79h0c19.06,23.32,22.96,53.61,10.1,78.57l-5.83,11.32c-26.93,52.24-90.51,78.2-153.4,62.88-70.59-17.2-159.99-42.68-220.72-73.32-17.17-8.66-36.9,1.97-36.9,19.71v180.51l-542.51-41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "M1651.46,1239.41c56.01-12.02,72.91,10.28,118.35-6.58,54.74-20.31,95.6-75.04,102.45-129.81,9.74-77.85-51.55-135.62-93.6-175.25-96.4-90.87-213.63-111.8-247.78-117.46-46.4-7.69-244.56-34.08-401.7,96.63-109.04,90.7-135.65,205.23-143.05,239.39-10.77,49.72-44.38,204.88,43.38,265.71,52,36.05,135.56,31.74,188.67,1.21,39.13-22.49,31.04-38.66,69.6-60.91,76.96-44.4,130.76,11.63,221.8-23.04,72.76-27.71,66.04-73.61,141.9-89.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M1666.5,2251.79c-103.12,0-195.44-23.1-275.07-68.91-96.84-55.71-154.47-133.77-185.76-189.44-35.21-62.65-57.21-133.09-58.85-188.43-1.93-65.34-26.97-114.72-49.06-158.28-27.49-54.22-51.24-101.05-26.16-162.17,1.36-3.32,3.54-8.3,6.25-14.53,15.97-36.59,53.38-122.27,47.61-154.05-2.98-16.42-12.12-25.14-13.32-26.22-3.91-2.68-8.69-4.2-13.74-5.8-2.92-.93-5.95-1.89-8.92-3.12-29.84-12.39-42.05-46.93-38.69-74.65,3.08-25.39,17-50.56,41.37-74.83,7.29-7.25,15.47-14.29,25.99-16.68,3.57-.81,7.27-1.02,11.03-.65,1.22-.77,2.46-1.53,3.72-2.28-3.11-5.16-5.74-10.62-7.74-16.49-10.23-30.06-2.43-65,23.87-106.79,12.07-19.18,55.8-80.72,112.24-67.29,4.85,1.15,9.42,2.81,13.7,4.89,5.73-3.86,11.94-7.56,18.6-11.07,84.67-44.59,193.01-36.22,269.61,20.8,3.71,2.76,7.14,7.44,8.84,12.31,16.04-7.38,38-6.31,66.59,3.13,33.45,11.04,79.58,30.48,93.99,71.67,5.75,16.44,6.08,35.66,.98,57.1-6.92,29.09-21.81,51.32-41.94,62.6-18.23,10.22-45.1,10.07-62.28-3.67-2.28,35.29-27.22,68.87-62.45,81.67-26.55,9.64-57.61,7.15-84.46-5.57-13.91,40.67-46.16,72.73-84.03,82.83-6.8,1.81-12.84,2.44-18.48,1.94-21.56-1.95-36.16-17.79-43.4-47.07-.72-2.9-2.89-5.05-5.8-5.75-2.93-.7-5.85,.25-7.81,2.53-2.55,2.97-6.38,4.33-10.24,3.67-3.82-.67-6.93-3.22-8.3-6.83-4.56-11.98-7.74-24.43-9.53-37.04-10.66-.31-21.47-2.84-31.7-7.38-.99,.81-1.99,1.61-3,2.4-1.89,16.7-6.74,34.64-14.59,54.05-11.08,27.41-27.47,41.03-46.14,38.4-5.88-.83-11.28-3.33-15.78-6.99-16.53,1.47-33.45-.22-49.24-5.03-10.36-3.16-15.07-8.89-14-17.04,.33-2.46,1.23-4.87,2.68-7.16,3.83-6.06,8.36-11.4,13.34-16.24-9.53,1.63-18.95,.55-27.33-3.27-27.17-12.35-35.21-47.12-27.08-72.25,3.96-12.24,11.27-23.84,21.6-34.43-1.49,1.34-2.94,2.74-4.36,4.15-22.73,22.63-35.67,45.8-38.47,68.89-3.33,27.47,10.66,55.03,32.54,64.11,2.56,1.06,5.26,1.92,8.11,2.83,5.63,1.79,11.46,3.65,16.67,7.3l.32,.24c.53,.44,13.06,11,16.93,32.3,6.32,34.81-30.57,119.29-48.29,159.89-2.68,6.14-4.82,11.05-6.17,14.32-23.32,56.85-.55,101.76,25.82,153.77,22.57,44.51,48.15,94.96,50.14,162.56,1.59,53.79,23.11,122.49,57.56,183.78,30.67,54.56,87.14,131.06,181.99,185.63,140.63,80.91,396.96,129.24,819.49-99.99,2.44-1.32,5.51-.42,6.84,2.03,1.33,2.45,.42,5.51-2.03,6.84-183.31,99.45-351.38,155.53-499.54,166.68-18.55,1.4-36.81,2.1-54.73,2.1Zm-337.57-1015.15c1.39,0,2.8,.16,4.2,.49,6.57,1.56,11.65,6.6,13.27,13.15,6.17,25,17.46,37.89,34.51,39.43,4.46,.41,9.34-.13,14.97-1.63,35.13-9.37,65.04-39.58,77.58-77.85-7.02-4.09-13.66-8.94-19.73-14.48-1.25-1.14-2.47-2.3-3.67-3.49-14.25-1.73-29.6-5.62-46.19-11.7-10.51-3.85-20.16-8.17-28.92-12.92-2.09-.29-4.17-.65-6.24-1.08,1.82,10.96,2.02,22.17,.47,33.17l-.9,6.39-5.99-2.42c-7.6-3.08-15.45-5.55-23.46-7.42-7.76,5.22-16.47,9.22-26.25,11.37-2.48,.55-4.99,.95-7.52,1.23,1.71,11.52,4.65,22.89,8.83,33.84,.04,.1,.15,.4,.6,.48,.24,.03,.58,.02,.84-.3,3.47-4.04,8.44-6.27,13.61-6.27Zm-127.14,50.22c6.77,.67,12.58-1.78,17.56-6-3.72,1.83-7.86,3.4-12.38,4.67-1.71,.48-3.44,.93-5.17,1.33Zm-47.79-44.32c-8.72,6.7-16.45,14.11-22.3,23.38-.66,1.04-1.07,2.11-1.2,3.09-.21,1.59-.5,3.79,6.94,6.06,12.25,3.73,25.27,5.43,38.14,5.06-2.56-4.45-4.2-9.53-4.64-14.94-.36-4.45-.14-8.81,.65-13.07-2.7,1.03-5.45,2.05-8.23,3.07l-4.93,1.79-1.6-5c-1-3.13-1.94-6.28-2.82-9.44Zm29.25,4.98c-1.97,5.41-2.73,11.03-2.25,16.86,.46,5.7,2.77,10.89,6.27,14.86,5.75-.73,11.43-1.87,16.97-3.42,7.22-2.02,24.27-8.17,26.8-21.53,1.07-5.7-.74-12-2.87-17.97-1.03-2.9-2.14-5.77-3.32-8.62-12.59,7.02-26.41,13.6-41.6,19.83Zm-20.5-11.3c.67,2.56,1.38,5.12,2.13,7.65,3.67-1.37,7.26-2.76,10.78-4.17,6.09-12.78,17.8-24.37,34.79-34.25,.85-.49,1.7-.98,2.56-1.46-.58-.98-1.17-1.95-1.76-2.92l-.25,.25c-10.47,10.31-22.96,18.38-35.03,26.19-4.5,2.91-8.94,5.78-13.22,8.72Zm70.9-13.64c1.44,3.41,2.78,6.86,4.02,10.34,1.17,3.27,2.25,6.66,2.95,10.12,3.71-10.58,6.42-20.65,8.15-30.26-4.82,3.36-9.86,6.62-15.13,9.79Zm-102.13-98.03c-15.8,10.5-32.99,26.17-39.84,47.34-6.82,21.09,.25,50.22,21.66,59.95,9.14,4.16,20.01,4.12,30.59-.1,2.28-.91,4.48-1.98,6.59-3.22-6.85-31.47-7.87-64.47-3.01-96.31-5.23-3.93-10.69-6.54-16-7.66Zm86.38,88.26c-.8,.45-1.59,.9-2.39,1.36-9.89,5.75-17.69,11.95-23.36,18.54,10.19-4.56,19.69-9.32,28.55-14.29-.9-1.89-1.84-3.76-2.8-5.61Zm-61.36-72.2c-3.36,26.96-2.37,54.63,2.91,81.27,4.89-4.56,8.77-10.03,11.18-15.97,8.32-20.49,2.64-46.47-14.09-65.3Zm328.9,64.63c24.75,12.18,53.57,14.74,78.08,5.85,35.06-12.73,59.46-50.14,55.54-85.17l-1.26-11.2c-10.76-.43-21.48-4.61-29.78-10.42-5.26-3.68-9.91-7.98-14.22-12.59-7.42,39.93-30.36,80.76-71.33,95.56-4.55,1.64-9.24,2.95-14.08,3.92-.77,4.76-1.76,9.44-2.96,14.05Zm-304.5-41.76c4.92,15.53,4.83,31.97-.95,46.22-.61,1.52-1.31,3.01-2.08,4.48,9.22-6.08,18.33-12.52,26-20.07,.57-.56,1.13-1.13,1.69-1.7-5.35-7.72-11.26-15.04-17.66-21.83-2.25-2.39-4.6-4.75-6.99-7.1Zm45.93,44.7c.89,1.7,1.74,3.41,2.58,5.14,7.47-4.54,14.44-9.27,20.96-14.2-8.07,2.42-15.95,5.44-23.54,9.06Zm239.55-14.89c3.17,2.49,6.47,4.79,9.88,6.9,.59-2.45,1.12-4.94,1.58-7.44-3.73,.36-7.5,.67-11.46,.54Zm-248.12,.02c1.26,1.98,2.48,3.99,3.67,6.02,7.15-3.44,14.55-6.38,22.13-8.81-3.04-2.33-5.97-4.87-8.76-7.6-2.01-1.97-3.96-4.03-5.83-6.19-3.2,5.85-6.95,11.41-11.21,16.59Zm53.49,1.21c7.2,2.69,14.63,4.26,21.98,4.62-.2-2.38-.35-4.77-.45-7.15-7.06,.28-14.1,.98-21.07,2.11-.15,.14-.31,.28-.46,.42Zm31.63-2.63c.1,2.32,.25,4.64,.45,6.96,2.2-.24,4.38-.59,6.53-1.06,4.57-1.01,8.9-2.49,12.97-4.36-6.61-.9-13.28-1.42-19.95-1.54Zm45.4-3.44c3.72,1.05,7.4,2.23,11.03,3.53,.37-5,.35-10.04-.04-15.04-3.37,4.07-7.03,7.94-10.99,11.51Zm-105.82-59.76c6.46,8.9,11.46,19.15,14.38,30.24,2.28,8.64,3.52,17.63,3.72,27.03,2.15-.47,4.31-.89,6.48-1.28,5.15-4.83,9.96-9.85,14.44-15.06,5.5-6.41,10.42-13.15,14.74-20.12,1.91-9.24,4.58-18.31,8.02-27.09-10.51-15.06-18.5-33.15-23.5-53.46-9.77,.32-19.94-2.4-28.83-8.01-15.29-9.66-23.63-24.14-26.58-39.79-1.32,1.39-2.55,2.84-3.69,4.34-7.53,9.94-11.84,21.16-14.09,32.33,16.48,4.73,26.82,21.9,31.14,37.33,3.07,10.96,4.29,22.31,3.77,33.55Zm60.29,53.13c11.21,.19,22.39,1.41,33.32,3.66,8.1-6.11,15-13.77,20.83-21.97-9.08-3.06-17.84-7.52-25.85-13.36-5.76-4.21-11.14-9.03-16.12-14.42-2.67,5.94-5.73,11.79-9.17,17.49-1.84,9.41-2.85,18.99-3.01,28.6Zm-144.82-53.9c5.54,5.78,11.56,11.4,17.7,17.12,6.41,5.98,13.05,12.17,19.12,18.61,6.15,6.52,11.87,13.51,17.1,20.85,3.94-5.16,7.35-10.74,10.2-16.61-11.16-15.77-19.23-35.36-23.63-57.66-.17-.89-.35-1.81-.52-2.76-4.83-1.42-9.9-2.19-15.17-2.19h-.06c-6.57,0-13.33,1.15-20.56,3.53-.01,.06-.03,.12-.05,.17-1.63,6.24-3,12.56-4.13,18.94Zm296.28,54.7c8.7,.83,16.91,.77,24.68-.19,3.01-26.89-1.12-55.92-12.1-84.21-3.6,18.57-11.72,38.63-28.91,53.08-1.21,1.02-2.45,1.98-3.73,2.91,5.39,10.46,12.12,20.05,20.06,28.4Zm-220.39-15.86c2.54,3.19,5.23,6.18,8.06,8.95,2.7,2.64,5.53,5.07,8.48,7.3-.36-7.45-1.46-14.61-3.27-21.49-1.47-5.58-3.69-11.24-6.57-16.7-1.47,7.52-3.72,14.88-6.71,21.94Zm59.33,4.6c-1.3,1.63-2.64,3.25-4.01,4.84-1.83,2.13-3.71,4.23-5.65,6.3,3.05-.27,6.11-.46,9.17-.57,.05-3.53,.21-7.05,.48-10.57Zm175.98-92.22c1.35,2.28,2.52,4.56,3.49,6.77,13.77,31.46,19.42,64.22,16.6,94.66,3.18-.76,6.28-1.69,9.3-2.78,39.97-14.44,61.08-56.73,66.15-96.13-2.19-2.74-4.32-5.51-6.44-8.25-1.96-2.54-3.91-5.08-5.9-7.57-25.45-31.96-55.51-54.38-86.93-64.85-3.7-1.23-7.43-2.29-11.19-3.18-1.87,1.32-3.67,2.68-5.43,4.07,12.63,14.46,19.51,35.22,20.5,61.94,.16,4.45,.17,9.65-.15,15.32Zm-70.63,88.74c2.82,1.16,5.6,2.23,8.3,3.22,11.34,4.15,22.04,7.23,32.13,9.25-5.05-6.45-9.52-13.42-13.37-20.79-8.28,4.35-17.48,7.12-27.06,8.32Zm-20.73-9.9c15.39,1.8,30.7-.69,43.43-7.53-4.41-10.13-7.7-20.88-9.8-32.01-6.15-4.05-11.86-8.77-17.04-14.03-1.86,6.05-3.78,12.15-5.84,18.1-3.27,9.47-8.08,21.3-14.77,33.17,1.33,.79,2.67,1.55,4.01,2.3Zm-168.66-45.89c3.72,16.86,9.67,31.91,17.58,44.58,2.79-8.06,4.59-16.48,5.32-24.96-6.27-7.96-14.03-14.86-22.9-19.62Zm154.76,37.21c.46,.32,.91,.64,1.38,.96,6.19-11.08,10.68-22.18,13.74-31.04,2.68-7.75,5.15-15.81,7.54-23.7-10.68-13.51-18.16-29.55-21.21-46.43-2.44-13.57-1.42-28.62,4.19-41.02-2.64,1.5-5.2,3.12-7.66,4.86-17.08,12.07-29.04,30.17-34.14,49.4,1.2,11.62,.77,23.62-1.23,35.62,.37,1.74,.81,3.47,1.32,5.17,7.81,.48,12.91,6.45,15.47,9.44,9.18,10.75,16.15,23.32,20.61,36.72Zm-44.69-23.98c5.4,6.37,11.36,11.96,17.82,16.68,2.67,1.95,5.44,3.73,8.27,5.34-10.23-9.31-18.01-19.61-23.16-30.77-.89,2.93-1.86,5.85-2.93,8.75Zm103.88-.7c1.73,6.98,3.98,13.75,6.71,20.26,.54-.42,1.07-.85,1.59-1.29,19.59-16.47,25.88-41.75,27.47-61.89-6.08-9.17-14.61-16.42-22-18.14-4.31-1.02-8.01-.15-11.3,2.62-3.69,3.11-6.01,8.02-6.38,13.46-.75,11.06-.25,22.02,1.42,32.64,1.67,.99,3.37,1.92,5.1,2.8,2.49,1.26,3.48,4.3,2.22,6.79-.94,1.86-2.85,2.87-4.82,2.75Zm199.81-10.01l4.97,8.13c11.74,19.22,40.19,21.25,58.37,11.05,23.8-13.34,33.43-40.89,37.06-56.13,4.64-19.54,4.41-36.85-.69-51.44-12.93-36.98-56.2-55.04-87.62-65.41-9.03-2.98-17.27-5.07-24.76-6.27,25.22,6.75,45.68,22.39,55.48,42.7,15.92,32.96,2.08,69.82-7.59,88.85-3.94,7.76-9.06,16.45-17.22,22.12-5.54,3.85-11.7,5.83-18,6.39Zm-289.26,2.38c3.38,6.16,7.57,11.77,12.33,16.88-3-5.21-6.46-10.14-10.37-14.72-.69-.81-1.34-1.52-1.96-2.16Zm-186.67-1.75c.82,1.08,1.66,2.15,2.52,3.2,.35-1.67,.71-3.32,1.09-4.98-1.19,.56-2.4,1.15-3.62,1.77Zm59.98-15.12c9.15,3.74,17.75,9.48,25.25,16.73-.41-6.42-1.47-12.79-3.2-18.96-3.43-12.26-11.14-25.8-22.93-29.95-1.18,11.77-.41,23.04,.89,32.18Zm83.88-32.48c4.21,16.69,10.56,31.72,18.73,44.56,1.36-1.72,2.91-3.24,4.61-4.53,.81-3.16,1.5-6.34,2.07-9.51-2.19-11.84-1.65-24.27,1.28-36.34-.4-3.39-.96-6.75-1.68-10.06-2.36,3-5.11,5.68-8.24,8.03-5.03,3.78-10.76,6.4-16.78,7.85Zm-46.02-138.25c-43.49,0-77.58,48.36-87.71,64.45-24.57,39.06-32.05,71.17-22.86,98.16,1.79,5.26,4.16,10.17,6.99,14.83,4.36-2.26,8.56-4.19,12.64-5.77,7.36-23.07,22.89-43.84,43.67-44.49,2.46-12.73,7.34-25.65,16.08-37.18,3.04-4.01,6.58-7.67,10.51-10.91-.15-13.57,3.28-27.3,9.36-38.96,6.96-13.35,17.51-25.57,31.51-36.55-2.11-.78-4.29-1.44-6.53-1.97-4.64-1.1-9.2-1.61-13.65-1.61Zm371.94,175.16c6.5,.43,12.95-.84,18.39-4.62,6.32-4.39,10.61-11.76,13.98-18.39,8.82-17.37,21.52-50.85,7.5-79.89-9.27-19.21-29.81-33.69-54.92-38.72-10.36-2.08-20.86-2.55-31.03-2.07-1.52,2.06-3.84,3.42-6.71,3.87l-16.33,2.6,5.05-4.71c-3.2,.46-6.33,.99-9.37,1.55,20.65,25.43,32.44,60.42,32.69,97.92,.04,5.37-.23,10.9-.8,16.51,5.49,6.62,11.26,12.65,18.11,17.46,6.28,4.4,14.57,7.78,22.84,8.46l-.13-1.16,.74,1.21Zm-218.98-11.27c3.58,4.07,7.49,7.83,11.68,11.24-.8-8.4-.93-16.95-.35-25.55,.55-8.16,4.18-15.64,9.95-20.5,5.73-4.83,12.68-6.46,20.1-4.73,7.4,1.73,14.32,6.48,20.11,12.44-.02-.67-.04-1.33-.06-1.98-.9-24.33-6.97-43.01-18.06-55.71-3.52,3.31-6.76,6.79-9.74,10.43-17.16,21-25.66,48.01-33.63,74.36Zm-201.73-26.49c-14.24,1.55-24.29,16.54-30.01,30.44,5.69-1.36,11.2-2.02,16.63-2.02h.07c4.57,0,9.12,.54,13.6,1.56-.99-8.87-1.4-19.19-.31-29.97Zm191.45-66.64c-12.32,10.49-15.37,29.72-12.22,47.17,2.32,12.91,7.53,25.28,14.93,36.18,7.71-25.08,16.52-50.33,33.39-70.97,3.14-3.84,6.54-7.51,10.22-11-.21-.16-.42-.33-.63-.49-3.93-2.98-8.17-5.22-12.52-6.65-11.51,.35-22.72,2.29-33.16,5.76Zm78.21-9.66c.97,.3,1.94,.61,2.9,.93,33.28,11.09,64.96,34.65,91.63,68.14,1.89,2.37,3.75,4.78,5.61,7.19,.04-1.54,.06-3.08,.05-4.59-.25-37.28-12.53-71.79-33.89-95.69-.63,.14-1.25,.28-1.87,.42-25.7,5.8-47.08,13.61-64.44,23.6Zm-231.04,22.73c1.43,15.6,8.51,30.26,22.65,39.19,6.58,4.16,13.97,6.31,21.24,6.47-.28-1.46-.54-2.93-.79-4.41-2.14-12.69-3.9-31.5-.8-51.18-4.85-.95-10.02-1.13-15.36-.47-9.5,1.16-18.94,4.88-26.94,10.39Zm52.02-6.75c-2.55,17.75-.91,34.77,1.04,46.34,.28,1.68,.58,3.34,.91,5,4.65-1.14,9.04-3.17,12.91-6.08,4.86-3.65,8.26-8.13,10.57-13.02-.19-.54-.39-1.07-.59-1.61-4.34-11.43-10.13-20.13-17.22-25.86-2.33-1.89-4.89-3.48-7.62-4.77Zm36.23,32.64c.42,1.33,.83,2.68,1.2,4.04,7.06-15.03,17.95-28.56,31.93-38.43,8.02-5.67,16.98-10.2,26.53-13.53,4.2-3.26,9.18-5.78,15.01-7.33,8.03-2.13,16.46-1.94,24.56,.42,9.95-.15,19.99,.73,29.97,2.75,18.78-12.46,42.47-22.05,71.5-28.98-31.38-28.26-80.55-40.46-136.2-33.53-35.64,4.44-62.13,15.7-78.84,33.49,7.51,11.9,12.57,24.95,15.28,36.68,3.98,17.17,3.6,32.27-.94,44.42Zm-34.29-42.82c4.35,1.78,8.39,4.16,12.02,7.09,6.05,4.89,11.26,11.44,15.55,19.54,.88-9.6-.59-19.11-2.18-25.95-2.28-9.81-6.32-20.64-12.19-30.69-6.57,9.33-10.72,19.65-13.21,30.02Zm-13.43-58.37c-14.85,10.86-25.83,23-32.75,36.28-4.3,8.25-7,17.63-7.8,27.1,7.92-4.43,16.73-7.39,25.74-8.49,6.42-.78,12.67-.57,18.56,.59,3.05-12.48,8.34-24.96,16.97-36.1-5.68-7.64-12.58-14.42-20.73-19.38Zm142.13-25.4c48.5,0,90.46,14.96,117.99,42.72,.06,.06,.11,.11,.16,.17,8.21-1.69,17.19-3.21,26.6-4.07-.96-2.43-2.84-5.54-5.38-7.44-73.55-54.76-177.58-62.78-258.88-19.97-4.79,2.52-9.33,5.14-13.6,7.85,7.07,4.94,13.21,11.05,18.46,17.79,18.4-18.68,46.44-30.46,83.49-35.08,10.62-1.32,21.03-1.97,31.15-1.97Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience1);
export default __webpack_public_path__ + "static/media/work-experience-1.f7e6f49af4b3b87c952af87ddb225be0.svg";
export { ForwardRef as ReactComponent };